"use client";

import { useState, useEffect } from "react";
import { Autocomplete, AutocompleteItem } from "@heroui/react";
import { cn } from "@/lib/utils";
interface EmotionOption {
  label: string;
  value: string;
  description: string;
}
interface EmotionSelectorProps {
  selectedEmotion: string | null;
  onEmotionChange: (value: string | null) => void;
  predefinedEmotions: EmotionOption[];
  className?: string;
  isCompact?: boolean;
  siteId: string;
  passedClassNames?: {
    base?: string;
    popoverContent?: string;
  };
}
export function EmotionSelector({
  selectedEmotion,
  onEmotionChange,
  predefinedEmotions,
  className = "",
  isCompact = false,
  siteId,
  passedClassNames
}: EmotionSelectorProps) {
  const [inputValue, setInputValue] = useState<string>("");
  const [storedEmotion, setStoredEmotion] = useState<string>(selectedEmotion || "");
  useEffect(() => {
    if (selectedEmotion) {
      setStoredEmotion(selectedEmotion);
      const isPresetEmotion = predefinedEmotions.some(emotion => emotion.value === selectedEmotion);
      if (!isPresetEmotion) {
        setInputValue(selectedEmotion);
      }
    }
  }, [selectedEmotion, predefinedEmotions]);
  const handleEmotionChange = (key: string) => {
    setStoredEmotion(key);
    if (key !== selectedEmotion) {
      onEmotionChange(key);
    }
  };
  return <div className={`w-[250px] ${!isCompact ? "flex flex-col gap-2" : ""} ${className}`} data-sentry-component="EmotionSelector" data-sentry-source-file="emotion-selector.tsx">
      <Autocomplete label="Target Emotion" labelPlacement="outside" placeholder="Select or type emotion" selectedKey={storedEmotion} defaultSelectedKey={storedEmotion} value={storedEmotion} onSelectionChange={key => {
      handleEmotionChange(key as string);
    }} onInputChange={value => {
      setInputValue(value);
    }} onKeyDown={e => {
      if (e.key === "Enter" && inputValue.trim()) {
        handleEmotionChange(inputValue);
      }
    }} defaultItems={[...predefinedEmotions, ...(storedEmotion && !predefinedEmotions.some(e => e.value === storedEmotion) ? [{
      label: storedEmotion,
      value: storedEmotion,
      description: "Custom emotion"
    }] : [])]} allowsCustomValue className="w-[250px]" classNames={{
      base: `max-w-xs ${passedClassNames?.base}`,
      popoverContent: `w-[250px] ${passedClassNames?.popoverContent}`
    }} popoverProps={{
      classNames: {
        content: "overflow-auto"
      }
      //   onMouseEnter: (e) => {
      //     document.body.style.overflow = "hidden";
      //     document.body.style.paddingRight = `${scrollbarWidth}px`;
      //   },
      //   onMouseLeave: (e) => {
      //     document.body.style.overflow = "auto";
      //     document.body.style.paddingRight = "0px";
      //   },
    }} size="md" variant="flat" listboxProps={{
      itemClasses: {
        base: "px-3 py-2 data-[hover=true]:bg-default-100"
      }
    }} inputProps={{
      classNames: {
        label: "text-default-400 text-small ",
        inputWrapper: "h-12 min-h-12"
      }
    }} data-sentry-element="Autocomplete" data-sentry-source-file="emotion-selector.tsx">
        {item => <AutocompleteItem key={item.value} textValue={item.label}>
            <div className={`flex flex-col ${isCompact ? "py-1" : ""}`}>
              <span className="text-small">{item.label}</span>
              {item.description && <span className={cn("text-tiny text-default-400", isCompact ? "line-clamp-2" : "line-clamp-4")}>
                  {item.description}
                </span>}
            </div>
          </AutocompleteItem>}
      </Autocomplete>
    </div>;
}